import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';

import { injectIntl } from 'react-intl';
import { Grid } from 'react-bootstrap';
import cx from 'classnames';
import { withQuery } from '../../hoc/withGraphql';
import { VerifiedIdSvgIcon, GuaranteeSvgIcon, LiveChatSvgIcon } from '../Common/Assets/SvgComponent/commonSvgIcon';
import s from './Feedback.css';

const Feedback = ({ data: { loading, getFooterSetting } }) => {
  if (loading) return <div />;

  return (
    <div className={cx(s.root, 'commonWordBreak')}>
      <div className={s.container}>
        <div className={s.feedbackContainer}>
          <Grid fluid>
            <div className={cx(s.feedbackRow)}>
              {getFooterSetting && (
                <>
                  <div className={cx(s.feedbackBox, 'feedbackBorderLeftRtl')}>
                    <div className={s.flex}>
                      <div className={s.feedbackIcon}>
                        <LiveChatSvgIcon />
                      </div>
                      <div>
                        <label className={cx(s.landingLabel)}>
                          {getFooterSetting.title1}
                        </label>
                      </div>
                    </div>
                    <div className={cx(s.feedbackContent, 'feedbackContent')}>
                      <label className={cx(s.landingCaption)}>
                        {getFooterSetting.content1}
                      </label>
                    </div>
                  </div>

                  <div className={cx(s.feedbackBox, 'feedbackBorderNoneRtl')}>
                    <div className={s.flex}>
                      <div className={s.feedbackIcon}>
                        <GuaranteeSvgIcon />
                      </div>
                      <div>
                        <label className={cx(s.landingLabel)}>
                          {getFooterSetting.title2}
                        </label>
                      </div>
                    </div>
                    <div className={cx(s.feedbackContent, 'feedbackContent')}>
                      <label className={cx(s.landingCaption)}>
                        {getFooterSetting.content2}
                      </label>
                    </div>
                  </div>

                  <div className={cx(s.feedbackBox, 'feedbackBorderRightRtl')}>
                    <div className={s.flex}>
                      <div className={s.feedbackIcon}>
                        <VerifiedIdSvgIcon />
                      </div>
                      <div>
                        <label className={cx(s.landingLabel)}>
                          {getFooterSetting.title3}
                        </label>
                      </div>
                    </div>
                    <div className={cx(s.feedbackContent, 'feedbackContent')}>
                      <label className={cx(s.landingCaption)}>
                        {getFooterSetting.content3}
                      </label>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Grid>
        </div>
      </div>
    </div>
  );
};

Feedback.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getFooterSetting: PropTypes.shape({
      title1: PropTypes.string.isRequired,
      content1: PropTypes.string.isRequired,
      title2: PropTypes.string.isRequired,
      content2: PropTypes.string.isRequired,
      title3: PropTypes.string.isRequired,
      content3: PropTypes.string.isRequired,
    }),
  }),
};

export default compose(
  injectIntl,
  withStyles(s),
  withQuery(gql`
    query getFooterSetting {
      getFooterSetting {
        id
        title1
        content1
        title2
        content2
        title3
        content3
      }
    }
  `, { options: { ssr: false } })
)(Feedback);
